import React from 'react'
import { Modal, ModalVariant } from '@at/design-system-patterns'
import { useAfterSignInUrl } from '../../hooks/after-signin-url-hook'

import * as Styled from './session-expired-modal.styles'

interface SaveSearchModalProps {
    handleHideModal: () => void
}
export const SessionExpiredModal = ({ handleHideModal }: SaveSearchModalProps) => {
    const { saveASearchAfterSignInUrl } = useAfterSignInUrl('SAVE_SEARCH')
    const savedSearchLoggedOut = () => (window.location.href = saveASearchAfterSignInUrl)

    return (
        <Modal
            isShowing={true}
            closeText={'Close'}
            hideFn={() => handleHideModal()}
            variation={ModalVariant.MAX}
            hasBackLink={true}
            focusId="modal-button"
        >
            <Styled.Icon title="Error" />
            <Styled.Title as="h1">Session expired</Styled.Title>
            <Styled.Description>
                <Styled.Paragraph>
                    We&apos;re really sorry, your session has expired. Please sign in again to save your search.
                </Styled.Paragraph>
            </Styled.Description>
            <Styled.ModalButtonContainer>
                <Styled.ModalButton
                    attributes={{
                        'data-testid': 'open-sign-in-page-button',
                    }}
                    text="Sign in"
                    onInteraction={() => {
                        savedSearchLoggedOut()
                    }}
                />
            </Styled.ModalButtonContainer>
        </Modal>
    )
}
